import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../Icon';
import { signOut } from '../../Actions/Login.action';
import { translate } from '../../Services/translation';
import styled, { css } from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { text } from '../../styling/mixins/typography';
import { hideFor } from '../../styling/utils/visibility';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const StyledMobileMenu = styled.div<{ showTrackingNumber: boolean }>`
  ${(props) => css`
    ${props.showTrackingNumber
      ? css`
          /* Styles for when showTrackingNumber is true */
          ${hideFor('xlarge')}
        `
      : css`
          /* Styles for when showTrackingNumber is false */
          ${hideFor('large')}
        `}
  `}
  position: relative;
  overflow: hidden;
  height: 56px;
  border: 1px solid ${getColor('grey', 300)};
  border-radius: 4px;
  margin-bottom: 1.6rem;

  select {
    width: 100%;
    height: 100%;
    color: transparent;
    margin-bottom: 1.6rem;
    border: none;

    &:focus {
      outline: none;
    }

    & option {
      ${text('medium')}
      color: ${getColor('grey', 900)};
    }
  }

  label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 0 1.6rem;
    pointer-events: none;
    text-transform: capitalize;

    .info-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .overline {
      ${text('medium')}
      color: ${getColor('grey', 600)};
    }
  }

  .caret-icon {
    color: ${getColor('grey', 900)};
    font-size: 2.4rem;
  }
`;

const MyPagesMobileMenu = ({ navigation, showTrackingNumber }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );

  return (
    <StyledMobileMenu showTrackingNumber={showTrackingNumber}>
      <label htmlFor="menu">
        <div className="info-wrapper">
          <span className="overline">
            {userInfo?.currentOrganizationName ??
              translate('mypage.site.title')}
          </span>
          <h5 className="name">
            {userInfo?.firstName} {userInfo?.lastName}
          </h5>
        </div>
        <Icon name="caret-down" className="caret-icon" />
      </label>
      <select
        id="menu"
        defaultValue={pathname}
        onChange={(e) => {
          e.target.value == 'log-out'
            ? signOut()
            : navigate(e.target.value);
        }}
      >
        {navigation.map((option) => (
          <option value={option.url} key={option.url + 'mobile'}>
            {option.name}
          </option>
        ))}
        <option value="log-out">{translate('general.sign-out')}</option>
      </select>
    </StyledMobileMenu>
  );
};

export default MyPagesMobileMenu;
